import { AiOutlinePlus } from '@react-icons/all-files/ai/AiOutlinePlus';
import { v4 as uuid } from 'uuid';
import { ZorbaButton } from '../../../../../components/forms';
import { optionTitles } from '../FiltersBuilder/constants';
import { BUTTON_VARIANT_LINK } from '../../../../../components/forms/ZorbaButton/constants';
import { camelCaseToTitleCase } from '../../../../../utils';

const convertSelectedFilterToString = (obj) => {
  if (typeof obj === 'string') return obj;

  if (!obj || typeof obj !== 'object') {
    return '';
  }

  if (Object.keys(obj).length > 1) {
    return `${obj[Object.keys(obj)[0]] || '0'} ${
      obj[Object.keys(obj)[1]] ? `- ${obj[Object.keys(obj)[1]]}` : ''
    }`;
  }
  const key = Object.keys(obj)[0];
  const values = obj[key];

  if (!Array.isArray(values)) {
    return '';
  }

  if (values.length === 0) {
    return '';
  }

  const result = values
    .map((value) => value?.formattedAddress || value)
    .join(', ');

  return `${result}`;
};

export const InitialFiltersState = ({
  appliedFilters,
  handleOpenFilterList,
  handleOpenFilterDetail,
  filterConfig,
  handleOnDelete,
}) => {
  const getTextFromAppliedFilter = (filterKey) => {
    const filter = appliedFilters[filterKey];
    return convertSelectedFilterToString(filter);
  };

  const getSelectedRadioValue = (filterKey) => {
    const filterObject = appliedFilters[filterKey];

    if (typeof filterObject === 'string') return 'is ';

    const key = Object.keys(filterObject)[0];

    return `${optionTitles[key]} `;
  };

  return (
    <>
      <h4>Applied filters ({Object.keys(appliedFilters).length})</h4>
      <div className="applied-filters-summary-container">
        {Object.keys(appliedFilters).length ? (
          Object.keys(appliedFilters).map((filterKey) => (
            <div key={uuid()}>
              <div className="delete-filter-container">
                <ZorbaButton
                  fullWidth={false}
                  variant={BUTTON_VARIANT_LINK}
                  onClick={() => handleOnDelete(filterKey)}
                >
                  Delete
                </ZorbaButton>
              </div>
              <div
                className="applied-filter-description"
                onClick={() => handleOpenFilterDetail(filterKey)}
              >
                <span className="applied-filter-title">{`${camelCaseToTitleCase(
                  filterKey,
                )} `}</span>
                <span>{getSelectedRadioValue(filterKey)}</span>
                <span className="applied-filter-title">
                  {getTextFromAppliedFilter(filterKey)}
                </span>
              </div>
            </div>
          ))
        ) : (
          <span>This report has no filters applied</span>
        )}
      </div>
      {filterConfig.length > 0 && (
        <div className="add-filter-container">
          <ZorbaButton
            onClick={handleOpenFilterList}
            icon={<AiOutlinePlus />}
            fullWidth={false}
            disabled={!filterConfig.length}
          >
            Add filter
          </ZorbaButton>
        </div>
      )}
    </>
  );
};
